module.exports = __webpack_public_path__ + "img/Tennis-Shoes.77743581.jpg";